// User roles supported across Eastern Union Bank
export const ROLES = Object.freeze({
  APPLICANT: "applicant",
  STAFF: "staff",
  ADMIN: "admin",
  SUPER_USER: "super_user",
  VERIFICATION_OFFICER: "verification officer",
});

// Local storage and session storage persistence keys
export const STORAGE_KEYS = Object.freeze({
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER_ROLE: "userRole",
  USER_TYPE: "userType",
  USER_EMAIL: "userEmail",
  USER_DATA: "userData",
  CURRENT_USER: "user",
});

// Role-based home routes
export const ROLE_HOME_ROUTES = Object.freeze({
  [ROLES.APPLICANT]: "/applicant/dashboard",
  [ROLES.STAFF]: "/staff/dashboard",
  [ROLES.ADMIN]: "/admin/dashboard",
  [ROLES.VERIFICATION_OFFICER]: "/staff/dashboard",
  [ROLES.SUPER_USER]: "/admin/dashboard",
});
